/* jshint esversion: 6 */
import axios from 'axios';
import qs from 'qs';
const instance = axios.create();
const isProd =process.env.NODE_ENV === 'production';
//  const baseUrl = isProd?'https://names.library.sh.cn/':'';
const baseUrl = 'https://names.library.sh.cn/';
instance.interceptors.request.use(config=>{
  const isToken = localStorage.getItem('token');
  // console.log('isToken',isToken);
  if(isToken){
    config.headers['token'] = localStorage.getItem('token') || '';
  }
  return config;
},err=>{
  Promise.reject(err);
});
const api={
  createFavorite:baseUrl + 'whzk/lcp/favorite/create',
  musicSearch:baseUrl+'whzk/lcp/music/search',
  musicList:baseUrl+'whzk/lcp/music/search',
  musicInfo:baseUrl+'whzk/lcp/music/info',
  phonorecordSearch:baseUrl+'whzk/lcp/phonorecord/search',
  phonorecordInfo:baseUrl+'whzk/lcp/phonorecord/info',
  phonorecordCollections:baseUrl+'whzk/lcp/phonorecord/collections',
  musicRecommondationsCreate:baseUrl+'whzk/lcp/music/recommondations/create',
  musicRecommondationsGet:baseUrl+'whzk/lcp/music/recommondations/get',
  phonorecordHome:baseUrl+'whzk/lcp/phonorecord/home',
  personFamous:baseUrl+'whzk/lcp/person/famous',
  personSearch:baseUrl+'whzk/lcp/person/search',
  personInfo:baseUrl+'whzk/lcp/person/info',
  orgSearch:baseUrl+'whzk/lcp/org/search',
  orgInfo:baseUrl+'whzk/lcp/org/info',
  phonorecordSuggest:baseUrl+'whzk/lcp/phonorecord/suggest',
  collectionRelations:baseUrl+'whzk/lcp/phonorecord/collection/relations',
  phonorecordByCollection:baseUrl+'whzk/lcp/phonorecord/byCollection',
  searchPhoto:baseUrl+'lcp/photo/search',
  specialData:baseUrl+'lcp/photo/collections',
  imageDetail:baseUrl+'lcp/photo/info?uri=',
  npDetail:baseUrl+'lcp/nianpu/info?uri=',
  npHome:baseUrl+'lcp/nianpu/home',
  searchNp:baseUrl+'lcp/nianpu/search',
  npType:baseUrl+'lcp/nianpu/types',
  getRecord:baseUrl+'whzk/lcp/phonorecord/search',
  collOrgList:baseUrl+'whzk/lcp/favorite/orgList',
  collMcList:baseUrl+'whzk/lcp/favorite/personList',
  collFav:baseUrl+'whzk/lcp/favorite/create',
  ncollFav:baseUrl+'whzk/lcp/favorite/cancel',
  collCongList:baseUrl+'whzk/lcp/favorite/musicList',
  phonorecordList:baseUrl+'whzk/lcp/favorite/phonorecordList',
  userIpInfo:baseUrl+'whzk/query/log/getUserIp?strongCheck=false',//获取用户IP,非加强验证 chenss 20240214
  feedBackAdd:baseUrl+"management/webapi/common/feedback/add"//反馈
};
/**
 * 曲目-查询
 * @param {Object} param
 * @returns
 */
export function musicSearch(param) {
  return instance.post(api.musicSearch, param);
}
export function whiteIpList() {
  // return instance.get('filtervis'); chenss 20241212 防止IP泄露，已挪到 player.vue中。
  return null;
}
/**
 * 曲目-详情
 * @param {Object} param
 * @returns
 */
export function musicInfo(param) {
  return instance.get(api.musicInfo, {params: param});
}

/**
 * 曲目-列表
 * @param {Object} param
 * @returns
 */
export function musicList(param) {
  return instance.get(api.musicSearch, {params: param});
}
/**
 * 唱片-查询
 * @param {Object} param
 * @returns
 */
export function phonorecordSearch(param) {
  return instance.post(api.phonorecordSearch, param);
}
export function phonorecordSearchGet(param) {
  return instance.get(api.phonorecordSearch, {params: param});
}
/**
 * 唱片-详情
 * @param {Object} param
 * @returns
 */
export function phonorecordInfo(param) {
  return instance.get(api.phonorecordInfo, {params: param});
}
/**
 * 唱片-专题-首页
 * @returns
 */
export function phonorecordCollections() {
  return instance.get(api.phonorecordCollections);
}
/**
 * 专题-详情
 * @returns
 */
export function phonorecordCollectionsGet(param) {
  return instance.get(api.phonorecordCollections, {params: param});
}
/**
 * 曲目-推荐
 * @param {Object} param
 * @returns
 */
export function musicRecommondationsCreate(param) {
  return instance.post(api.musicRecommondationsCreate, param);
}
/**
 * 曲目-推荐-列表(首页-精选曲目)
 * @returns
 */
export function musicRecommondationsGet() {
  return instance.get(api.musicRecommondationsGet);
}
/**
 * 唱片-首页-馆藏唱片
 * @returns
 */
export function phonorecordHome(param) {
  return instance.get(api.phonorecordHome, {params: param});
}
/**
 * 乐人-首页-名家
 * @returns
 */
export function personFamous() {
  return instance.get(api.personFamous);
}
/**
 * 乐人-检索
 * @param {Object} param
 * @returns
 */
export function personSearch(param) {
  return instance.get(api.personSearch, {params: param});
}


export function personSearchPost(param) {
  const isToken = localStorage.getItem('token')
  if(isToken){
    instance.interceptors.request.use(config=>{
      config.headers['token'] = localStorage.getItem('token') || ''
      return config
    },err=>{
      Promise.reject(err)
    })
  }
  return instance.post(api.personSearch, param);
}
/**
 * 乐人-详情
 * @param {Object} param
 * @returns
 */
export function personInfo(param) {
  return instance.get(api.personInfo, {params: param});
}
/**
 * 组织机构-简单/高级检索
 * @param {Object} param
 * @returns
 */
export function orgSearch(param) {
  const isToken = localStorage.getItem('token')
  if(isToken){
    instance.interceptors.request.use(config=>{
      config.headers['token'] = localStorage.getItem('token') || ''
      return config
    },err=>{
      Promise.reject(err)
    })
  }
  return instance.post(api.orgSearch, param);
}
/**
 * 组织机构-详情
 * @param {Object} param
 * @returns
 */
export function orgInfo(param) {
  return instance.get(api.orgInfo, {params: param});
}
/**
 * 检索框-suggest
 * @param {Object} param
 * @returns
 */
export function phonorecordSuggest(param) {
  return instance.get(api.phonorecordSuggest, {params: param});
}
/**
 * 首页-专题图表
 * @param {Object} param
 * @returns
 */
export function collectionRelations(param) {
  return instance.get(api.collectionRelations, {params: param});
}
/**
 * 专题-详情-唱片列表
 * @param {Object} param
 * @returns
 */
export function phonorecordByCollection(param) {
  return instance.get(api.phonorecordByCollection, {params: param});
}
/**
 * 收藏-suggest
 * @param {Object} param
 * @returns
 */
export function collPhonorecord(param) {
  /*
  instance.interceptors.request.use(config=>{
    const isToken = config.data.isToken || false
    console.log('isToken',isToken)
    if(isToken){
      config.headers['token'] = localStorage.getItem('token') || ''
    }
  },err=>{
    Promise.reject(err)
  })
  */
  return instance.get(api.ncollPhonorecord, {params: param});
}
/**
 *
 */
export function createFavorite(param) {

  return instance.get(api.createFavorite, {params: param});
}
/**
 * 取消收藏-suggest
 * @param {Object} param
 * @returns
 */
export function ncollPhonorecord(param) {
  return instance.get(api.ncollPhonorecord, {params: param});
}
/**
 * 个人收藏乐人列表
 * @param {Object} param 
 * @returns 
 */
export function collMcList(param) {
  instance.interceptors.request.use(config=>{
    const isToken = localStorage.getItem('token')
    if(isToken){
      config.headers['token'] = localStorage.getItem('token') || ''
      return config
    }
  },err=>{
    Promise.reject(err)
  })
  return instance.post(api.collMcList,param);
}
/**
 * 个人收藏机构列表
 * @param {Object} param 
 * @returns 
 */
export function collOrgList(param) {
  instance.interceptors.request.use(config=>{
    const isToken = localStorage.getItem('token')
    if(isToken){
      config.headers['token'] = localStorage.getItem('token') || ''
      return config
    }
  },err=>{
    Promise.reject(err)
  })
  
  return instance.post(api.collOrgList,param);
}
/**
 * 个人收藏曲目列表
 * @param {Object} param 
 * @returns 
 */
 export function collCongList(param) {
  instance.interceptors.request.use(config=>{
    const isToken = localStorage.getItem('token')
    if(isToken){
      config.headers['token'] = localStorage.getItem('token') || ''
      return config
    }
  },err=>{
    Promise.reject(err)
  })
  return instance.post(api.collCongList,param);
}
/**
 * 个人收藏唱片列表
 * @param {Object} param 
 * @returns 
 */
 export function phonorecordList(param) {
  instance.interceptors.request.use(config=>{
    const isToken = localStorage.getItem('token')
    if(isToken){
      config.headers['token'] = localStorage.getItem('token') || ''
      return config
    }
  },err=>{
    Promise.reject(err)
  })
  return instance.post(api.phonorecordList,param);
}
/**
 * 
 * @returns 获取用户IP
 */
 export function userIpInfo() {
  return instance.get(api.userIpInfo);
}
/**
 * 
 * @returns 用户反馈
 */
 export function feedBackAdd(param) {
  instance.interceptors.request.use(config=>{
    const isToken = localStorage.getItem('token')
    if(isToken){
      config.headers['token'] = localStorage.getItem('token') || ''
      return config;
    }
  },err=>{
    Promise.reject(err)
  })
  return instance.post(api.feedBackAdd,param);
}
/**
 * 添加 收藏-suggest
 * @param {Object} param 
 * @returns 
 */
export function collFav(param) {
  instance.interceptors.request.use(config=>{
    const isToken = localStorage.getItem('token')
    if(isToken){
      config.headers['token'] = localStorage.getItem('token') || '';
      // config.headers['Content-Type'] = localStorage.getItem('token') || '';
      return config
    }
  },err=>{
    Promise.reject(err)
  })
  return instance.post(api.collFav, qs.stringify(param));
}

/**
 * 取消收藏-suggest
 * @param {Object} param 
 * @returns 
 */
export function ncollFav(param) {
  instance.interceptors.request.use(config=>{
    const isToken = localStorage.getItem('token')
    if(isToken){
      config.headers['token'] = localStorage.getItem('token') || ''
      return config
    }
  },err=>{
    Promise.reject(err)
  })
  return instance.post(api.ncollFav, qs.stringify(param));
}
export function npType() {
  return instance.get(api.npType)
}
export function specialData() {
  return instance.get(api.specialData)
}
export function imageDetail(id) {
  return instance.get(api.imageDetail+id)
}
export function npDetail(id) {
  return instance.get(api.npDetail+id)
}
export function searchPhoto(param) {
  return instance.post(api.searchPhoto,param)
}
export function searchNp(param) {
  return instance.post(api.searchNp,param)
}
export function npHome() {
  return instance.get(api.npHome)
}
export function getRecord(param) {
  // console.log(api.getRecord);
  return instance.post(api.getRecord,param)
}
